// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","238":"7becef6f","239":"dfdb0d71","252":"b6c71761","450":"b7d758e8","453":"d855a71b","455":"ec63873d","557":"ab0ce3c1","692":"1bfb36e9","762":"2f6136d4"}[chunkId] + ".chunk.js";
};